import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Compass, Home, Search } from "lucide-react";

import { OutcomeState } from "@/components/app/outcome-state";
import { Button } from "@/components/ui/button";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <OutcomeState
      eyebrow="Route Error"
      title="Page not found"
      description="The link or route you opened does not exist in the current product workspace."
      icon={Compass}
      tone="error"
      meta={
        <div className="space-y-1">
          <p className="font-medium">Requested path</p>
          <p className="text-sm opacity-80">{location.pathname}</p>
        </div>
      }
      actions={
        <>
          <Button asChild variant="outline">
            <Link to="/">
              <Home className="mr-2 h-4 w-4" />
              Return home
            </Link>
          </Button>
          <Button asChild>
            <Link to="/dashboard">
              <Search className="mr-2 h-4 w-4" />
              Go to dashboard
            </Link>
          </Button>
        </>
      }
    />
  );
};

export default NotFound;
